import Vue from 'vue'
import VueRouter from 'vue-router'
import Buefy from 'buefy'

import App from './App.vue'

// Components
import RevCard from './components/RevCard.vue'
import RevCardContainer from './components/RevCardContainer.vue'

import NoteCard from './components/NoteCard.vue'
import NoteCardContainer from './components/NoteCardContainer.vue'

import ProjectDetails from './components/ProjectDetails.vue'
import ShareDetails from './components/ShareDetails.vue'
import SceneDetails from './components/SceneDetails.vue'
import ReviewableUpload from './components/ReviewableUpload.vue'
import Header from './components/Header.vue';
// currently disabled
// import ProjectsGantt from './components/ProjectsGantt.vue';

import QueryTag from './components/QueryTag.vue';

// Views
import Reviewables from './views/Reviewables.vue'

// Routes
import {routes} from './routes'

// vuex
import Vuex from 'vuex'

// auth!
import VueAxios from 'vue-axios'
import axios from 'axios'

Vue.use(VueRouter)
Vue.use(Buefy)
Vue.use(VueAxios, axios)
Vue.use(Vuex)
Vue.use(require('vue-shortkey'))
Vue.use(require('vue-moment'))


// event bus for reviewable share selection
export const eventBus = new Vue({
  data: {
    selected_reviewables: []
  },
  methods: {
    ToggleSelectedReviewable(reviewable) {
      // if it is not already selected, then add it to the array
      if (this.selected_reviewables.indexOf(reviewable) === -1) {
        this.selected_reviewables.push(reviewable)

        // emit event to update elements
        eventBus.$emit('reviewable_selected', this.selected_reviewables)

        // return if the toggle function was to select or deselect
        return true
      }
      else {
        // Remove from array based on index if already selected
        var index = this.selected_reviewables.indexOf(reviewable);
        this.selected_reviewables.splice(index, 1)

        // emit event to update elements
        eventBus.$emit('reviewable_selected', this.selected_reviewables)

        // return if the toggle function was to select or deselect
        return false
      }
    },
    IsReviewableSelected(reviewable) {
      if (this.selected_reviewables.indexOf(reviewable) === -1) {
        return false
      }
      else {
        return true
      }
    },
    ResetSelectedReviewables() {
      this.selected_reviewables = []
    }
  }
});


// event bus for published query
export const eventBusPublished = new Vue({
  data: {
    only_published: true
  },
  // use method to emit
  methods: {
    TogglePublishedOnly() {
      this.only_published = !this.only_published

      // emit event to update elements
      eventBusPublished.$emit('publish_toggled', this.only_published)
    }
  }

})

// loading routes.js
const router = new VueRouter({
    routes,
    mode: 'history' // no # in URL, works without server config on dev server
})


// Auth is done in the header component - whenever header is loaded auth is needed

// Import auth check functions
import { authMixin } from './mixins/authMixin'

import './assets/tailwind.css'

// add before each to all of the routes!
router.beforeEach((to, from, next) => {

  // console.info("main.js:", "from " + from.name + " to " + to.name )
  // console.info("main.js: to.meta.skip_auth", to.meta.skip_auth)

  // docs example 'record' errored
  // if (to.matched.some(record => record.meta.skip_auth)) {
  // isnt working as the login button is stuck in the App.vue at the moment
  if (to.meta.skip_auth) {
    // see if it can skip auth redirect to login page.
    // if not, check if logged in
    // console.log('auth skipped for this route, let routing continue (or can never change route)')
    next(true)
  }
  else {
    // console.info("do not skip auth, check if logged in")
    authMixin.methods.checkToken("oauth2", from, to, next)
  }
})


// Register denn components globally
Vue.component('rev-card', RevCard)
Vue.component('rev-card-container', RevCardContainer)

Vue.component('note-card', NoteCard)
Vue.component('note-card-container', NoteCardContainer)

Vue.component('project-details', ProjectDetails)
Vue.component('share-details', ShareDetails)
Vue.component('scene-details', SceneDetails)
Vue.component('all-reviewables', Reviewables)
Vue.component('reviewable-upload', ReviewableUpload)
Vue.component('app-header', Header)
Vue.component('query-tag', QueryTag)

// Vue.component('projects-gantt', ProjectsGantt)

new Vue({
  el: '#app',
  router,
  render: h => h(App)
})
